import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: { padding: 30, fontFamily: 'Helvetica', fontSize: 10 },
  header: { backgroundColor: '#F57C00', color: '#ffffff', padding: 15, marginBottom: 20 },
  headerTitle: { fontSize: 18, fontWeight: 'bold' },
  headerSubtitle: { fontSize: 10, opacity: 0.9, marginTop: 4 },
  warning: { backgroundColor: '#FFF3E0', border: '2px solid #F57C00', padding: 10, marginBottom: 15, textAlign: 'center' },
  warningText: { fontSize: 12, fontWeight: 'bold', color: '#E65100' },
  statsRow: { flexDirection: 'row', marginBottom: 20, gap: 10 },
  statBox: { flex: 1, border: '1px solid #e0e0e0', padding: 12, backgroundColor: '#fff3e0', textAlign: 'center' },
  statValue: { fontSize: 20, fontWeight: 'bold', color: '#E65100', marginBottom: 2 },
  statLabel: { fontSize: 8, color: '#666666' },
  section: { marginBottom: 15 },
  sectionTitle: { fontSize: 12, fontWeight: 'bold', backgroundColor: '#ffcc80', padding: 8, marginBottom: 10 },
  table: { marginBottom: 20 },
  tableHeader: { flexDirection: 'row', backgroundColor: '#ffe0b2', borderBottom: '2px solid #F57C00' },
  tableRow: { flexDirection: 'row', borderBottom: '1px solid #e0e0e0' },
  tableRowAlt: { flexDirection: 'row', borderBottom: '1px solid #e0e0e0', backgroundColor: '#fff8e1' },
  cell: { padding: 6 },
  cellAwb: { width: 70 },
  cellFecha: { width: 65 },
  cellDestino: { width: 40 },
  cellPallet: { width: 70 },
  cellGuia: { width: 90 },
  cellUn: { width: 50, textAlign: 'center' },
  cellClase: { width: 40, textAlign: 'center' },
  cellPiezas: { width: 40, textAlign: 'center' },
  headerCell: { fontWeight: 'bold', fontSize: 8 },
  claseBadge: { backgroundColor: '#F57C00', color: '#ffffff', padding: '2 6', fontSize: 9 },
  footer: { position: 'absolute', bottom: 30, left: 30, right: 30, borderTop: '1px solid #e0e0e0', paddingTop: 10, flexDirection: 'row', justifyContent: 'space-between', fontSize: 8, color: '#666666' },
});

const ReporteDGPDF = ({ data, filters }) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Text style={styles.headerTitle}>⚠️ Reporte de Dangerous Goods</Text>
          <Text style={styles.headerSubtitle}>
            Período: {filters.fecha_inicio} al {filters.fecha_fin}
          </Text>
        </View>

        <View style={styles.warning}>
          <Text style={styles.warningText}>DANGEROUS GOODS - MERCANCÍA PELIGROSA</Text>
        </View>

        <View style={styles.statsRow}>
          <View style={styles.statBox}>
            <Text style={styles.statValue}>{data.resumen.total_items}</Text>
            <Text style={styles.statLabel}>ITEMS DG</Text>
          </View>
          <View style={styles.statBox}>
            <Text style={styles.statValue}>{data.resumen.vuelos_con_dg}</Text>
            <Text style={styles.statLabel}>VUELOS CON DG</Text>
          </View>
        </View>

        {data.por_clase?.length > 0 && (
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Distribución por Clase</Text>
            <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 5 }}>
              {data.por_clase.map((c) => (
                <View key={c.clase} style={{ backgroundColor: '#ffe0b2', padding: '4 8', marginBottom: 4 }}>
                  <Text style={{ fontSize: 9 }}>Clase {c.clase || 'N/A'}: {c.cantidad} items</Text>
                </View>
              ))}
            </View>
          </View>
        )}

        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <Text style={[styles.cell, styles.cellAwb, styles.headerCell]}>VUELO</Text>
            <Text style={[styles.cell, styles.cellFecha, styles.headerCell]}>FECHA</Text>
            <Text style={[styles.cell, styles.cellDestino, styles.headerCell]}>DEST</Text>
            <Text style={[styles.cell, styles.cellPallet, styles.headerCell]}>PALLET</Text>
            <Text style={[styles.cell, styles.cellGuia, styles.headerCell]}>GUÍA</Text>
            <Text style={[styles.cell, styles.cellUn, styles.headerCell]}>UN</Text>
            <Text style={[styles.cell, styles.cellClase, styles.headerCell]}>CLASE</Text>
            <Text style={[styles.cell, styles.cellPiezas, styles.headerCell]}>PCS</Text>
          </View>
          {data.items.slice(0, 35).map((item, idx) => (
            <View key={idx} style={idx % 2 === 0 ? styles.tableRow : styles.tableRowAlt}>
              <Text style={[styles.cell, styles.cellAwb]}>{item.awb}</Text>
              <Text style={[styles.cell, styles.cellFecha]}>{new Date(item.fecha).toLocaleDateString()}</Text>
              <Text style={[styles.cell, styles.cellDestino]}>{item.destino}</Text>
              <Text style={[styles.cell, styles.cellPallet]}>{item.placa}</Text>
              <Text style={[styles.cell, styles.cellGuia]}>{item.guia}</Text>
              <Text style={[styles.cell, styles.cellUn]}>{item.un || 'N/A'}</Text>
              <Text style={[styles.cell, styles.cellClase, { fontWeight: 'bold' }]}>{item.clase || 'N/A'}</Text>
              <Text style={[styles.cell, styles.cellPiezas]}>{item.tpiezas}</Text>
            </View>
          ))}
        </View>

        <View style={styles.footer}>
          <Text>Generado: {new Date().toLocaleString()}</Text>
          <Text>Pallet Control - Sistema de Gestión de Carga</Text>
        </View>
      </Page>
    </Document>
  );
};

export default ReporteDGPDF;

